import {
  GROUP_ID_PERSONAL,
  getSelectedUserGroupIdCookie,
  getSelectedUserGroupIdFromCookies,
} from '@/features/business/utils/selectedUserGroupCookie'
import { type RequestCookies } from '@shared/request_type'

type GetActiveGroupIdParams = {
  cookies: RequestCookies | undefined
}

const isActiveBusinessGroup = (groupId: string | undefined) =>
  Boolean(groupId && groupId !== GROUP_ID_PERSONAL)

export const getActiveGroupId = ({ cookies }: GetActiveGroupIdParams): string | undefined => {
  const groupId = cookies
    ? getSelectedUserGroupIdFromCookies(cookies)
    : getSelectedUserGroupIdCookie()

  if (!isActiveBusinessGroup(groupId)) {
    return
  }

  return groupId
}
